import { Building, ChartBar, Lightbulb, UserCheck } from "lucide-react";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { SectionShell } from "./SectionShell";

/** 3つの時期は同じ重み。片方だけ大きくしない（オーナー指示 2026-09-10）。 */
const PHASES: { key: string; icon: ReactNode }[] = [
  { key: "startup", icon: <Lightbulb aria-hidden="true" focusable="false" /> },
  { key: "growth", icon: <ChartBar aria-hidden="true" focusable="false" /> },
  { key: "mature", icon: <Building aria-hidden="true" focusable="false" /> },
];

export const SupportAreasSection = () => {
  const { t } = useTranslation();

  return (
    <SectionShell
      id="support"
      icon={<UserCheck aria-hidden="true" focusable="false" />}
      heading={t("support.heading")}
      note={t("support.lifecycle")}
    >
      <div className="support-grid">
        {PHASES.map(({ key, icon }) => (
          <article className="phase" key={key} data-reveal>
            <h3>
              {icon}
              {t(`support.${key}`)}
            </h3>
            <ul>
              {[1, 2, 3].map((n) => (
                <li key={n}>{t(`support.${key}_item${n}`)}</li>
              ))}
            </ul>
          </article>
        ))}
      </div>
    </SectionShell>
  );
};
